import { Box } from '@mui/material';
import type { FeedbackTone } from './feedbackTones';
import { FEEDBACK_PILL_RADIUS } from './feedbackTones';

/** The tinted pill a type or a status is drawn as. */
const FeedbackChip = ({ tone, label }: { tone: FeedbackTone; label: string }) => (
  <Box
    component="span"
    sx={{
      justifySelf: 'start',
      alignSelf: 'center',
      fontSize: 11,
      fontWeight: 700,
      borderRadius: FEEDBACK_PILL_RADIUS,
      px: 1.25,
      py: '3px',
      bgcolor: tone.bg,
      color: tone.ink,
      whiteSpace: 'nowrap'
    }}
  >
    {label}
  </Box>
);

/** A small round dot — urgency, and the leading mark of a type or status option. */
export const FeedbackDot = ({ color, size = 8 }: { color: string; size?: number }) => (
  <Box
    component="span"
    sx={{ width: size, height: size, borderRadius: FEEDBACK_PILL_RADIUS, bgcolor: color, flex: 'none' }}
  />
);

export default FeedbackChip;
